export default "__VITE_ASSET__z6g3A2Q4__"